module.exports = __webpack_public_path__ + "img/47.75bb327b.jpg";